module.exports = __webpack_public_path__ + "534fc0967078272679b4df8c4008f898.png";